import React, {Component} from 'react';
import PropTypes from 'prop-types';
import PhotogalleryItem from '../../containers/photogallery-item';
import Wrapper from '../../components/wrapper';
import './styles.css';

export default class PhotogalleryLayout extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    layout: PropTypes.string,
    children: PropTypes.arrayOf(PropTypes.node),
    openModal: PropTypes.func,
    index: PropTypes.number,
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    layout: null,
    children: null,
    openModal: null,
    index: null,
  };

  constructor(props) {
    super(props);
  }

  render() {
    const {
      containerId,
      containerClass,
      layout,
      children,
      openModal,
      index,
    } = this.props;
    //
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
      >
        <table className="PhotogalleryLayout">
          {(() => {
            if (layout === 'Large') {
              return (
                <tbody>
                <tr>
                  <td className="PhotogalleryLayout__td" ref="td">
                    <PhotogalleryItem {...children[0].props} openModal={this.openModal} index={index}/>
                  </td>
                </tr>
                </tbody>
              )
            } else if (layout === 'Medium') {
              return (
                <tbody>
                <tr>
                  <td className="PhotogalleryLayout__td3" ref="td3">
                    <PhotogalleryItem {...children[0].props} openModal={this.openModal} index={index} mbTwoColumn />
                  </td>
                  <td className="PhotogalleryLayout__td3" ref="td3">
                    <PhotogalleryItem {...children[1].props} openModal={this.openModal} index={index + 1} mbTwoColumn />
                  </td>
                </tr>
                </tbody>
              )
            } else if (layout === '2-Small-Left-Medium-Right') {
              return (
                <tbody>
                <tr>
                  <td className="PhotogalleryLayout__td4" ref="td4">
                    <div className="PhotogalleryLayout__box">
                      <PhotogalleryItem {...children[0].props} openModal={this.openModal} index={index}/>
                    </div>
                    <div className="PhotogalleryLayout__box2">
                      <PhotogalleryItem {...children[1].props} openModal={this.openModal} index={index + 1}/>
                    </div>
                  </td>
                  <td className="PhotogalleryLayout__td2" ref="td2">
                    <PhotogalleryItem {...children[2].props} openModal={this.openModal} index={index + 2}/>
                  </td>
                </tr>
                </tbody>
              )
              // return (
              //   <tbody>
              //   <tr>
              //     <td className="PhotogalleryLayout__td4" ref="td4">
              //       <PhotogalleryItem {...children[0].props} openModal={this.openModal} index={index}/>
              //     </td>
              //     <td className="PhotogalleryLayout__td2" rowSpan="2" ref="td2">
              //       <PhotogalleryItem {...children[1].props} openModal={this.openModal} index={index + 1}/>
              //     </td>
              //   </tr>
              //   <tr>
              //     <td className="PhotogalleryLayout__td4" ref="td4">
              //       <PhotogalleryItem {...children[2].props} openModal={this.openModal} index={index + 2}/>
              //     </td>
              //   </tr>
              //   </tbody>
              // )
            } else if (layout === 'Medium-Left-2-Small-Right') {
              return (
                <tbody>
                <tr>
                  <td className="PhotogalleryLayout__td2" rowSpan="2" ref="td2">
                    <PhotogalleryItem {...children[0].props} openModal={this.openModal} index={index}/>
                  </td>
                  <td className="PhotogalleryLayout__td4" ref="td4">
                    <PhotogalleryItem {...children[1].props} openModal={this.openModal} index={index + 1}/>
                  </td>
                </tr>
                <tr>
                  <td className="PhotogalleryLayout__td4" ref="td4">
                    <PhotogalleryItem {...children[2].props} openModal={this.openModal} index={index + 2}/>
                  </td>
                </tr>
                </tbody>
              )
            }
          })()}
        </table>
      </Wrapper>
    );
  }

  //
  openModal = (index) => {
    if (this.props.openModal !== null) this.props.openModal(index);
  };

}



// WEBPACK FOOTER //
// ./src/containers/photogallery-layout/index.jsx